import Api from "@/services/AxiosAPI";

export default {
  //orderform
  send_orderform(data) {
    const post = new FormData();
   
    post.append("name", data.contactname?data.contactname:''); 
    post.append("course_name", data.course_name?data.course_name:'');
    post.append("date_start", data.date_start?data.date_start:'');
    post.append("date_from", data.date_from?data.date_from:'');
    post.append("date_to" , data.date_to?data.date_to:'');
    post.append("room_availability" , data.room_availability?data.room_availability:'');
    post.append("equip_options" , data.equip_options?data.equip_options:'');
    post.append("other_vlaue" , data.other_vlaue?data.other_vlaue:'');
    post.append("course_price" , data.course_price?data.course_price:'');
    post.append("max_delegates" , data.max_delegates?data.max_delegates:'');
    post.append("vat1", data.vat1?data.vat1:'');
    post.append("sub_total", data.sub_total?data.sub_total:'');
    post.append("inv_first_name", data.inv_first_name?data.inv_first_name:'');
    post.append("inv_last_name" , data.inv_last_name?data.inv_last_name:'');
    post.append("inv_job_title", data.inv_job_title?data.inv_job_title:'');
    post.append("inv_email", data.inv_email?data.inv_email:'');
    post.append("inv_address1" , data.inv_address1?data.inv_address1:'');
    post.append("inv_address2", data.inv_address2?data.inv_address2:'');
    post.append("inv_city", data.inv_city?data.inv_city:'');
    post.append("inv_postcode" , data.inv_postcode?data.inv_postcode:'');
    post.append("inv_phone", data.inv_phone?data.inv_phone:'');
    post.append("dl_first_name", data.dl_first_name?data.dl_first_name:'');
    post.append("dl_last_name", data.dl_last_name?data.dl_last_name:'');
    post.append("dl_job_title", data.dl_job_title?data.dl_job_title:'');
    post.append("dl_email", data.dl_email?data.dl_email:'');
    post.append("dl_address1", data.dl_address1?data.dl_address1:'');
    post.append("dl_address2", data.dl_address2?data.dl_address2:'');
    post.append("dl_city" , data.dl_city?data.dl_city:'');
    post.append("dl_postcode", data.dl_postcode?data.dl_postcode:'');
    post.append("dl_phone", data.dl_phone?data.dl_phone:'');
    post.append("position", data.position?data.position:'');
    return Api.postData('sendgroupbookingemail', post)
      .then(responses => {
        return responses
      });


  },
  get_id(id) {
    return Api.getData('products/' + id)
      .then(responses => {
        return responses.data
      });


  },
  plceorder(auth, data, hcrUserData, consigneeData) {
    const post = new FormData();
    var myJSON = JSON.stringify(data);
    post.append("products", myJSON);
    post.append("customer_id", auth);
    
    if (hcrUserData){
      post.append("hcr_user_id", hcrUserData.id);
      post.append("hcr_user_data", JSON.stringify(hcrUserData));
    }
    
    if (consigneeData){
      if (consigneeData.consignee_id){
        post.append("consignee_id", consigneeData.consignee_id);
      } else {
        post.append("consignee_data", JSON.stringify(consigneeData));
      }
    }

    return Api.postData('order-create', post)
      .then(responses => {
        return responses
      });

  },
  placeCourseOrder(course) {
    const post = new FormData();
    //var course = JSON.parse(data);
    post.append("email", course.email);
    post.append("product_descriptor_id", course.product_descriptor_id);
    post.append("fee_per_person", course.fee_per_person);
    post.append("training_course_id", course.training_course_id);
    post.append("first_name", course.first_name);
    post.append("last_name", course.last_name);
    post.append("company_name", course.company_name);
    post.append("phone", course.phone);
   
    if (course.hcr_user_id){
      post.append("hcr_user_id", course.hcr_user_id);
      if (course.hcr_user_data)
        post.append("hcr_user_data", course.hcr_user_data);
    }
  
    //post.append("terms_accepted", "");
    return Api.postData('training-course-confirm-booking', post)
      .then(responses => {
        return responses
      });

  },
  getcountry() {
    return Api.getData('country-list')
      .then(responses => {
        return responses
      });

  },

}